/* eslint-disable no-undef */
/* eslint-disable no-underscore-dangle */

if (window.__POWERED_BY_QIANKUN__) {
  // eslint-disable-next-line camelcase
  __webpack_public_path__ = process.env.PUBLIC_PATH;
}
